import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

@createModule('ProductPropertiesAndDownloads')
/**
 * product-list module implementation.
 *
 * @author Robert Schork <robert.schork@namics.com>
 */
export class ProductPropertiesAndDownloads extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		setTimeout(() => {
			$('#datasheet-chapter-productDescription').remove();
			$('#datasheet-chapter-healthAndSafetyInformation').remove();
			$('#datasheet-chapter-disclaimer').remove();
			$('#datasheetContactInformation').remove();
			$('.contentSlot').on('click', 'h2, h3, h4, h5, h6', (event: Event) => {
				this.toggleContainer(event);
			});
			// Remove arrow from section headings
			$('.contentSlot h2').each(function(index, element: HTMLElement) {
				const $this = $(element);
				if ($this.next().is('h3, h4, h5, h6')) {
					$this.addClass('section-heading').off('click');
				}
			});
		}, 1000);

		resolve();
	}

	toggleContainer(event: Event) {
		//Open or close this panel
		var isActive = $(event.target).hasClass('active');
		$('.contentSlot > h2, .contentSlot > h3,.contentSlot > h4,.contentSlot > h5,.contentSlot > h6').removeClass(
			'active'
		);
		if (!isActive) {
			$(event.target).toggleClass('active');
		}
		$(event.target)
			.next()
			.slideToggle('fast');
		//close other panels
		let nextElement: any = $(event.target).next();
		$('.indentedParagraph')
			.not(nextElement)
			.slideUp('fast');
	}
	stop() {}
}
